import React from "react";

export default function WebWork() {
  return (
    <div
      className="grid fr2 work mt1"
      style={{ paddingTop: "4rem", paddingBottom: "4rem" }}
    >
      <div className="flexColumn" style={{ justifyContent: "center" }}>
        <div className="flex platformWeb mb05">
          <img src={require("../Assets/webplatform.png")} alt="" />
        </div>
        <h1 className="bigHeader">Website & Software Development</h1>
        <p className="bigSpan mt1">
          Build websites for your business, blogs and company to promote more.
        </p>
      </div>
      <div className="grid noPadding" style={{ overflow: "hidden" }}>
          <img
            src={require("../Assets/test3.png")}
            alt=""
            style={{ width: "100%" }}
          />
      </div>
    </div>
  );
}
